export default "__VITE_ASSET__BXePB5zt__";